
import { PageContext, _, dateUtil } from '@zto/zpage'
import { formatPrice } from '@/utils/math'
import {
  ZdsOrderDeliveryType,
  ZdsOrderDeliveryTypeOptions, ZdsOrderPayModeOptions,
  ZdsOrderRefundStatus,
  ZdsOrderStatus,
  ZdsOrderStatusOptions
} from "@/pages/orderlist/config";
import {
  batchDeliverGoodsHandle,
  deliverGoodsHandle,
  exportOut1688ExcelHandle, getOrderDetailHandle,
  refundDialog
} from "@/pages/orderlist/_actions";
import dayjs from "dayjs";
import {CouponStatus} from "@/config";

export default {
  body: {
    type: 'crud',

    actions: {
      query: { api: '/admin/order/queryOrderListPage' },
      // 批量发货
      batchDeliverGoods:{
        ...batchDeliverGoodsHandle()
      },
      // 导出1688表格
      exportInExcel:{
        ...exportOut1688ExcelHandle(),
      },

      // 确认收货
      receiptGoods:{
        api: 'tuxi.zds.order.pc.manualReceipt',
        payload: { orderId: '${data.row.soNo}' },
        message: '当前订单是否确认已收货？'
      },

      deliverGoods: {
        ...deliverGoodsHandle(false),
        message: '发货成功'
      },
      refund:{
        ...refundDialog()
      },
      detail:{
        ...getOrderDetailHandle()
      },

      moreLogistics:{
        ...deliverGoodsHandle(true)
      },
      // export: {
      //   apiParams: ({ data }: PageContext) => {
      //     // const batchNo = data.actionData.row.batchNo
      //     return { exportType: 'tuxi.dms.coupon.exportRedeemCodeInfo', parameter: { batchNo, groupType, bizCode } }
      //   }
      // }
    },

    search: {
      labelWidth: 100,
      span: 6,

      items: [
        { label: '订单编号', type: 'input', prop: 'orderId', span: 6 },
        { label: '订单状态',
          type: 'select',
          prop: 'orderStatus',
          options: ZdsOrderStatusOptions
        },
        // {
        //   label: '支付方式',
        //   type: 'select',
        //   prop: 'payPlatform',
        //   options: ZdsOrderPayModeOptions,
        //   // default: 'WECHAT'
        // },
        // {
        //   label: '是否物流发货',
        //   type: 'select',
        //   prop: 'fulfillmentType',
        //   options: ZdsOrderDeliveryTypeOptions,
        // },

        { label: '时间类型', type: 'select', prop: 'timeType',
          default:1,
          options: [
            { label: '下单时间',value:1 },
            { label: '付款时间',value:2 },
          ],
          clearable: false
        },
        {
          label: '时间范围',
          labelWidth: 100,
          type: 'date-range-picker',
          prop: 'startTime',
          toProp: 'endTime',
          // span: 8
        },
        // {
        //   label: '时间范围',
        //   labelWidth: 100,
        //   type: 'date-range-picker',
        //   prop: 'startDate',
        //   toProp: 'endDate',
        //   // span: 8
        // }
      ]
    },
    toolbar: {
      items: [
        { action: 'batchDeliverGoods', label: '批量发货' },
        // { action: 'exportOut1688Excel', label: '导出表格1688专用' },
        // { action: 'exportInExcel', label: '导出列表' },
        // { action: 'exportInExcel', label: '导出明细' }
      ]
    },
    table: ({app}: PageContext) => ({
      operation: {
        width: 150,
        items: [
          {
            action: 'deliverGoods',
            label: '发货',
            visibleOn: ({ data }: PageContext) => {
              // const isExistRefund = [ZdsOrderRefundStatus.REFUNDING, ZdsOrderRefundStatus.REFUND_SUCCESS, ZdsOrderRefundStatus.REFUND_FAIL].includes(data.row.returnStatus);
              return [ZdsOrderStatus.WAIT_DELIVERY].includes(data.row.orderStatusCode) ;
            },
          },
          { action: 'detail' },
        ]
      },
      columns: [
        { label: '订单编号', prop: 'orderId', width: 200 },
        { label: '下单时间', prop: 'createTime', width: 200,
          formatter: (row: any) => {
            const date = dayjs(row.createTime)
            return date.format('YYYY-MM-DD HH:mm:ss')
          }
        },
        { label: '付款时间', prop: 'payTime', width: 200,formatter: (row: any) => {
          if (!row.payTime) {
            return '--'
          }
            const date = dayjs(row.payTime)
            return date.format('YYYY-MM-DD HH:mm:ss')
          } },
        { label: '订单金额', prop: 'orderPrice',

          width: 100
        },

        { label: '订单状态', prop: 'orderStatus',
          formatter: { name: 'enumStr', options: ZdsOrderStatusOptions },
          // formatter: (data: any) => {
          //   // @ts-ignore
          //   return ZdsOrderStatusMap[data.orderStatus] || '--';
          // },
          width: 100
        },
        { label: '用户姓名', prop: 'receiverName',width: 100 },
        { label: '用户手机号', prop: 'receiverMobile', width: 100 },
        { label: '收货地址', prop: 'fullAddress', width: 100 },
        // { label: '是否物流发货', prop: 'deliveryMode',
        //   formatter: { name: 'enumStr', options: ZdsOrderDeliveryTypeOptions },
        //   // formatter: (data: any) => {
        //   //   // @ts-ignore
        //   //   return ZdsOrderDeliveryTypeMap[data.deliveryMode ] || '--';
        //   // },
        //   width: 100 },
        { label: '物流公司', prop: 'logisticsCompanyName', width: 100 },
        { label: '物流单号', prop: 'logisticsNo', width: 100 },
        // { label: '退款状态', prop: 'returnStatus',
        //   formatter: (data: any) => {
        //     // @ts-ignore
        //     return ZdsOrderRefundStatusMap[data.returnStatus ] || '--';
        //   },
        //   width: 100
        // },
        // { label: '员工姓名', prop: 'cardName', width: 100 },
        // { label: '员工工号', prop: 'cardNo', width: 100 },
        // { label: '员工手机号', prop: 'cardPhone', width: 100 },
      ]
    }),

  }
}
